import TokenService from '@/helpers/token';
import { IRootState } from '@/store';
import { ActionContext, ActionTree } from 'vuex';
import {
    login,
    sendEmail,
    changePassword,
    register,
    registerApp,
    resendOtp,
    verifyUserRegisted,
    getMe,
    logOut,
    resetPassword,
    uploadImage,
    uploadKyc,
    masterDataCountries,
} from '../services';
import { IRegisterUser, IUserResponse } from '../types';
import { authMutations, IAuthState } from './auth';

const authAction: ActionTree<IAuthState, any> = {
    async setTypeIdentity(context: ActionContext<IAuthState, any>, type: string) {
        context.commit(authMutations.SET_TYPE_IDENTITY, type);
    },
    // login
    async login(
        context: ActionContext<IAuthState, IRootState>,
        loginBody: { email: string; password: string },
    ) {
        const response = await login({
            email: loginBody.email,
            password: loginBody.password,
        });
        if (response.success) {
            const token = response?.data?.access_token || '';
            TokenService.setToken(token);
            context.commit(authMutations.SET_LOGIN_RESULT, {
                loginSuccess: true,
            });
        } else {
            context.commit(authMutations.SET_LOGIN_RESULT, {
                loginSuccess: false,
            });
        }
        return response;
    },
    // log out
    async logOut(context: ActionContext<IAuthState, IRootState>) {
        const response = await logOut();
        if (response.success) {
            TokenService.removeToken();
            context.commit(authMutations.SET_USER_LOGINED, {});
            TokenService.removeKKycName();
        }
        return response;
    },
    // call api get me
    async getMe(context: ActionContext<IAuthState, IRootState>) {
        const response = await getMe();
        if (response.success) {
            context.commit(authMutations.SET_USER_LOGINED, response?.data);
        }
        return response;
    },

    // send email
    async sendEmail(
        context: ActionContext<IAuthState, IRootState>,
        params: { email: string },
    ) {
        const response = await sendEmail(params);
        return response;
    },
    // change password
    async changePassword(
        context: ActionContext<IAuthState, IRootState>,
        params: { old_password: string; password: string; password_confirmation: string },
    ) {
        const response = await changePassword(params);
        return response;
    },
    // register
    async register(
        context: ActionContext<IAuthState, IRootState>,
        params: IRegisterUser,
    ) {
        delete Object.assign(params, {
            'g-recaptcha-response': params.g_recaptcha_response,
        })['g_recaptcha_response'];
        const response = await register(params);
        if (response.success) {
            const user = {
                ...params,
                token: response?.data?.token,
            };
            context.commit(authMutations.SET_USER_REGISTERED, user);
        }
        return response;
    },

    async registerApp(
        context: ActionContext<IAuthState, IRootState>,
        params: IRegisterUser,
    ) {
        delete Object.assign(params, {
            'recaptchaToken': params.g_recaptcha_response,
        })['g_recaptcha_response'];
        const response = await registerApp(params);
        if (response.success) {
            const user = {
                ...params,
                token: response?.data?.token,
            };
            localStorage.setItem('USER_REGISTER', JSON.stringify(user));
            context.commit(authMutations.SET_USER_REGISTERED, user);
        }
        return response;
    },


    // set token user register
    async setTokenUserRegister(context: ActionContext<IAuthState, any>, user) {
        context.commit(authMutations.SET_USER_REGISTERED, user);
    },
    // verify user registered
    async verifyUserRegisted(
        context: ActionContext<IAuthState, IRootState>,
        params: IUserResponse,
    ) {
        const response = await verifyUserRegisted(params);
        return response;
    },
    // resend otp
    async resendOtp(context: ActionContext<IAuthState, IRootState>, token: string) {
        const response = await resendOtp(token);
        return response;
    },
    // reset password
    async resetPassword(
        context: ActionContext<IAuthState, IRootState>,
        params: { password: string; password_confirmation: string; token: string },
    ) {
        const response = await resetPassword(params);
        return response;
    },
    async uploadImage(
        context: ActionContext<IAuthState, IRootState>,
        params: { image: string },
    ) {
        const response = await uploadImage(params);
        return response;
    },
    async uploadKyc(
        context: ActionContext<IAuthState, IRootState>,
        params: {
            type: string;
            national: string;
            paper_number: string;
            image_before: string;
            image_after: string;
            image_portrait: string;
        },
    ) {
        const response = await uploadKyc(params);
        return response;
    },
    async masterDataCountries() {
        const response = await masterDataCountries();
        return response;
    },
};
export default authAction;
